import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Optionally log error info to an error reporting service
        // console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        color: "#d32f2f",
                        background: "#fdeaea",
                        padding: "2rem",
                        borderRadius: "12px",
                        margin: "1rem 0",
                    }}>
                    <h3>Something went wrong rendering this chart.</h3>
                    <p>{this.state.error?.message || "Unknown error."}</p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
